import React, { useEffect, useState } from "react";
import { Clock, User } from "lucide-react";
import api from "@/lib/api";

export default function Blogs() {
  const [blogs, setBlogs] = useState([]);
  useEffect(() => { api.get("/blogs").then((r) => setBlogs(r.data)); }, []);

  return (
    <div className="max-w-7xl mx-auto px-6 py-16">
      <div className="mb-10">
        <div className="text-xs uppercase tracking-[0.3em] text-[#D4AF37] mb-3">Wisdom Journal</div>
        <h1 className="font-serif text-4xl md:text-5xl tracking-tight max-w-3xl">
          Stories from the <span className="italic gold-gradient">threshold of the ancient & new.</span>
        </h1>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
        {blogs.map((b) => (
          <div key={b.id} data-testid={`blog-card-${b.slug}`} className="group rounded-xl bg-[#0A0C10] border border-white/10 hover:border-[#D4AF37]/40 transition-colors overflow-hidden">
            <div className="aspect-[16/10] overflow-hidden">
              <img src={b.cover} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" alt={b.title} />
            </div>
            <div className="p-6">
              <div className="font-serif text-xl leading-tight">{b.title}</div>
              <p className="text-sm text-[#A0A4AB] mt-3 leading-relaxed">{b.excerpt}</p>
              <div className="flex items-center gap-4 mt-4 text-xs text-[#A0A4AB]">
                <span className="flex items-center gap-1"><User size={12}/> {b.author}</span>
                <span className="flex items-center gap-1"><Clock size={12}/> {b.read_time}</span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
